import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const transcriptionContract = c.router(
  {
    batchTranscribe: {
      method: 'POST',
      path: '/batch-transcribe',
      responses: {
        200: z.object({}),
      },
      body: z.object({
        appointmentId: z.string(),
      }),
      summary: 'Schedules a batch transcription job for the given appointment',
    },
    markChunkFinal: {
      method: 'POST',
      path: '/mark-chunk-final',
      responses: {
        200: z.object({ isFinalChunk: z.boolean() }),
        404: z.object({}),
      },
      body: z.object({
        appointmentId: z.string().uuid(),
        transcriptId: z.string().uuid(),
        isFinalChunk: z.boolean(),
      }),
      summary: 'Marks a transcript chunk as final or not final',
    },
  },
  {
    pathPrefix: '/:tenantId/transcription',
  },
);
